<app-header [transparent]="transparent" />
<div class="bg_2 box">
  <app-sidebar
    (headingEvent)="receiveHeading($event)"
    (toggleSidebarEvent)="receiveSidebarEvent($event)"
  />

  <div
    class="main_content_1 bg_2 p-b-60"
    [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'"
  >
    <!-- <div class=" setting1">
            <div class="p-10">
                <img src="../../../assets/icons/supoort_icon.png" class="m-r-16"/>Support
            </div>
            <div class="p-10 cursor_pointer" *ngIf="authService.isAuthenticated()">
                <a href="https://agropat.chemrobotics.com/profile" target="_blank" class="m-r-16 text_decoration_none">
                    <img src="../../../assets/icons/setting_icon.png" alt="Setting Icon" />
                </a>
                Setting
            </div>
        </div> -->
    <!-- <div class="p-b-30 p-x-40 border_bottom body">
      <div class="dis_flex jc_space_bet">
        <div>
          <span class="font_24 weight_800">{{ heading }}</span>
        </div>
        <div class="dis-flex-1">
          <div class="p-10 cursor_pointer">
            <a
              href="https://www.chemrobotics.com/contact"
              target="_blank"
              class="text_decoration_none"
            >
              <img
                src="../../../assets/icons/supoort_icon.png"
                class="m-r-16"
              />Support</a
            >
          </div>
          <div
            class="p-10 cursor_pointer"
            *ngIf="authService.isAuthenticated()"
          >
            <a
              href="https://www.chemrobotics.com/edit_profile"
              target="_blank"
              class="m-r-16 text_decoration_none"
            >
              <img
                src="../../../assets/icons/setting_icon.png"
                alt="Setting Icon"
              />
              Setting
            </a>
          </div>
        </div>
      </div>
    </div> -->
    <div class="min_height_550">
      <router-outlet />
    </div>
  </div>
</div>
<app-footer />
